import React from "react";
import confImg from "../assets/confgImg.png"; // Adjust the path as necessary

const FscConfigure = () => {
  return (
    <div>
      <div className="d-flex flex-column justify-content-center align-items-center mt-1">
        <h1>Instructions</h1>
        <p>Click the button below to download the bookmarklet file.</p>
        <a
          href="assets/PVC-Cards-Generator.html"
          download="PVC-Cards-Generator.html"
          className="btn btn-primary inline-block p-2 m-2 text-white  rounded shadow hover:bg-blue-700"
        >
          👉 Donwload Configuratin
        </a>
        <ol>
          <li>
            Click the{" "}
            <span className="text-primary">"Donwload Configuratin"</span>{" "}
            button.
          </li>
          <li>
            Open the{" "}
            <span className="text-danger">PVC-Cards-Generator.html</span> File
            from Downloads.
          </li>
          <div className="mt-2 d-flex justify-content-center align-items-center">
            <img src={confImg}></img>
          </div>
          <li>Drag the PVC Card Generator to Bookmark as shown above image.</li>{" "}
          <li>Added as BookmarkConfiguration Done.</li>{" "}
          <li>
            Use the PVC Card Generator bookmark on the New Card Generator (EPDS
            Telangana Food Security Act) page.
          </li>{" "}
        </ol>{" "}
      </div>

      <div style={{ marginTop: "30px" }}></div>
    </div>
  );
};

export default FscConfigure;
